/**
 * Vehicle trait module
 */

export * from './vehicleTrait.js';
export * from './aboardTrait.js';
export * from './vehicleBehavior.js';
export * from './vehicleEvents.js';
